var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#F4D8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0665 13.2574C23.4572 12.9142 22.7128 12.9142 22.1035 13.2574L15.0185 17.2482C14.3893 17.6026 14 18.2686 14 18.9907V26.8875C14 27.6096 14.3893 28.2757 15.0185 28.6301L22.1035 32.6208C22.7128 32.9641 23.4572 32.9641 24.0665 32.6208L31.1515 28.6301C31.7807 28.2757 32.17 27.6096 32.17 26.8875V18.9908C32.17 18.2686 31.7807 17.6026 31.1515 17.2482L24.0665 13.2574ZM21.9565 18.6465C22.1066 18.2635 22.4761 18.0114 22.8876 18.0114H23.1769C23.5883 18.0114 23.9578 18.2635 24.1079 18.6465L26.8685 25.6905C27.0534 26.1622 26.7056 26.6722 26.1989 26.6722C25.8984 26.6722 25.6296 26.4854 25.5248 26.2038L24.891 24.5009H21.1735L20.5396 26.2038C20.4348 26.4854 20.166 26.6722 19.8656 26.6722C19.3589 26.6722 19.011 26.1622 19.1959 25.6905L21.9565 18.6465ZM23.0136 19.5398L21.6086 23.3364H24.4558L23.0633 19.5398H23.0136Z",
    fill: "#23262F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocale);
export default __webpack_public_path__ + "static/media/locale.8674d0ce.svg";
export { ForwardRef as ReactComponent };